import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import Immutable from "immutable";
import formValueSelector from "redux-form/lib/formValueSelector";

import SchemaField from "../../../component/SchemaField";
import Address from "../Address";

import "./CustomerDetails.scss";
import isEqual from "lodash/isEqual";

/**
 * CustomerDetails
 */
class CustomerDetails extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isBusinessAccount: PropTypes.bool.isRequired,
    isCompany: PropTypes.bool.isRequired,
    className: PropTypes.string,
    schema: PropTypes.instanceOf(Immutable.Map).isRequired
  };

  static defaultProps = {
    className: ""
  };

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  renderRadioLabel = ({ title }) => <div>{title}</div>;

  render() {
    //
    const { isCompany, schema, className, isBusinessAccount, t } = this.props;
    return (
      <div className={`${className} Cart__CustomerDetails`}>
        <SchemaField
          name="customer.type"
          disabled={isBusinessAccount}
          inputType="radio"
          schema={schema}
          labelRenderer={this.renderRadioLabel}
        />

        {isCompany && (
          <div>
            <SchemaField
              name="customer.companyName"
              disabled={isBusinessAccount}
              autoComplete="section-customer billing organization"
              schema={schema}
            />
            <SchemaField
              name="customer.cocNumber"
              disabled={isBusinessAccount}
              autoComplete="section-customer billing cocNumber"
              schema={schema}
            />
          </div>
        )}

        <SchemaField
          name="customer.lastName"
          disabled={isBusinessAccount}
          autoComplete="section-customer billing name"
          schema={schema}
        />

        <Address
          schema={schema}
          name="customer"
          disabled={isBusinessAccount}
          autoCompletePrefix="section-customer billing"
        />

        <SchemaField
          name="customer.phone"
          disabled={isBusinessAccount}
          autoComplete="section-customer billing tel-national"
          schema={schema}
        />
        <SchemaField
          name="customer.emailAddress"
          disabled={isBusinessAccount}
          autoComplete="section-customer billing email"
          schema={schema}
          tooltip={t("emailaddress.helptext")}
        />
        <SchemaField name="customer.sendAnonymously" schema={schema} wrappedLabel />

        {isBusinessAccount && (
          <div className="alert alert-warning">
            {t("You are logged in with a business account")}
            <br />
            <span
              dangerouslySetInnerHTML={{
                __html: t("Edit your details using your {{profileLink}}")
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const valueSelector = formValueSelector("cart");
export default translate()(
  connect(state => ({
    isCompany: valueSelector(state, "customer.type") === "company",
    schema: state.cart.get("schema"),
    isBusinessAccount: state.cart.getIn(["context", "isBusinessAccount"], false)
  }))(CustomerDetails)
);
